import { RouteItem } from '@eastcoal/router/types/route'

import { MINE_PAGE_PATH } from './constants/path'
import { MINE_ACTION_UUID, MINE_PAGE_UUID } from './constants/uuid'

export const mineRoute: RouteItem = {
  title: '矿场管理',
  path: MINE_PAGE_PATH,
  hideChildrenInMenu: true,
  uuid: MINE_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理矿场',
      uuid: MINE_ACTION_UUID
    }
  ]
}
